<template>
  <div id="dashboard-page">
    <div class="page-wrapper">
      <div class="block-content mt-0">
        <div class="filters-form">
          <FitlerForm @clear="clearFilterForm" :filter-form="filterObjects">
            <ElButton :loading="summaryLoading" slot="query-btn" @click="querySummaryData" type="primary"> 查询 </ElButton>
          </FitlerForm>
        </div>
        <div class="summaries">
          <Summaries v-model="currSummaries" :loading="summaryLoading" :data="summaryList" />
        </div>
      </div>
      <div class="block-content">
        <div class="ad">
          <div class="title">投放数据</div>
          <LineChart ref="lineChartRef" />
        </div>
      </div>

      <div class="tables">
        <!-- 人员排行 -->
        <div class="block-content">
          <div class="users">
            <BlockTitle
              label="人员排行"
              @date-type-change="getUsersRankData"
              @sort-type-change="getUsersRankData"
              :form="rankObjects.users.query"
            >
              <template #default="{ form }">
                <el-select
                  v-model="form.gameGroupIds"
                  multiple
                  filterable
                  collapse-tags
                  clearable
                  placeholder="应用组"
                  style="width: 180px"
                  size="small"
                  @change="getUsersRankData"
                >
                  <el-option v-for="app in GAME_GROUPS" :key="app.id" :label="app.name" :value="app.id"> </el-option>
                </el-select>
              </template>
            </BlockTitle>

            <div class="table" v-loading="rankObjects.users.tableLoading">
              <el-table class="common-el-table-styles" :data="rankObjects.users.tableData" :height="300" style="width: 100%">
                <el-table-column label="排行" width="40" class-name="rank-col">
                  <template slot-scope="{ $index }">
                    <img v-if="$index < 3" class="rank-image" :src="`/images/homepage-rank-index${$index + 1}.png`" alt="rank-index1" />
                    <div v-else>{{ $index + 1 }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="name" label="人员" width="80"> </el-table-column>
                <el-table-column prop="amount" label="实际消耗"> </el-table-column>
                <el-table-column prop="createRoleNum" label="创角数"> </el-table-column>
                <el-table-column prop="createRoleCost" label="创角成本"> </el-table-column>
                <el-table-column prop="newPayCost" label="付费成本">
                  <template slot-scope="{ row }">
                    <div>{{ row.newPayCost.toFixed(2) }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="newRoleRate" label="ROI">
                  <template slot-scope="{ row }">
                    <div>{{ row.newRoleRate | toPercent }}</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="block-content">
          <BlockTitle label="媒体分布" @date-type-change="getPieData" :form="rankObjects.medias.query">
            <!-- 应用组下拉 -->
            <template #default="{ form }">
              <el-select
                v-model="form.gameGroupIds"
                multiple
                filterable
                collapse-tags
                clearable
                placeholder="应用组"
                style="width: 180px"
                size="small"
                @change="getPieData"
              >
                <el-option v-for="app in GAME_GROUPS" :key="app.id" :label="app.name" :value="app.id"> </el-option>
              </el-select>
            </template>

            <template #slot1="{ form }">
              <el-select v-model="form.sort" style="width: 90px" size="small" @change="getPieData">
                <el-option v-for="item in mediaItems" :key="item.sort" :label="item.label" :value="item.sort"> </el-option>
              </el-select>
            </template>
          </BlockTitle>
          <div style="position: relative" v-loading="rankObjects.medias.chartLoading">
            <div class="pie-chart" style="width: 100%; height: 300px" ref="pieChartRef"></div>
          </div>
        </div>
        <div class="block-content">
          <BlockTitle
            label="素材排行"
            @date-type-change="getMaterialsRankData"
            @sort-type-change="getMaterialsRankData"
            :form="rankObjects.materials.query"
          >
            <template #default="{ form }">
              <el-select
                v-model="form.mediaIds"
                multiple
                filterable
                collapse-tags
                clearable
                placeholder="媒体"
                style="width: 180px"
                size="small"
                @change="getMaterialsRankData"
              >
                <el-option v-for="app in MEDIAS" :key="app.mediaId" :label="app.mediaName" :value="app.mediaId"> </el-option>
              </el-select>
            </template>
          </BlockTitle>
          <div class="table" v-loading="rankObjects.materials.tableLoading">
            <el-table class="common-el-table-styles" :data="rankObjects.materials.tableData" :height="300" style="width: 100%">
              <el-table-column prop="date" label="排行" width="40" class-name="rank-col">
                <template slot-scope="{ $index }">
                  <img v-if="$index < 3" class="rank-image" :src="`/images/homepage-rank-index${$index + 1}.png`" alt="rank-index1" />
                  <div v-else>{{ $index + 1 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="imageName" label="素材名称" show-overflow-tooltip width="240"> </el-table-column>
              <el-table-column prop="amount" label="实际消耗"> </el-table-column>
              <el-table-column prop="createRoleNum" label="创角数"> </el-table-column>
              <el-table-column prop="createRoleCost" label="创角成本"> </el-table-column>
              <el-table-column prop="newPayCost" label="付费成本">
                <template slot-scope="{ row }">
                  <div>{{ row.newPayCost.toFixed(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="newRoleRate" label="ROI">
                <template slot-scope="{ row }">
                  <div>{{ row.newRoleRate | toPercent }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="block-content">
          <BlockTitle
            label="应用排行"
            @date-type-change="getAppsRankData"
            @sort-type-change="getAppsRankData"
            :form="rankObjects.apps.query"
          >
            <template #default="{ form }">
              <el-select
                v-model="form.mediaIds"
                multiple
                filterable
                collapse-tags
                clearable
                placeholder="媒体"
                style="width: 180px"
                size="small"
                @change="getAppsRankData"
              >
                <el-option v-for="app in MEDIAS" :key="app.mediaId" :label="app.mediaName" :value="app.mediaId"> </el-option>
              </el-select>
            </template>
          </BlockTitle>

          <div class="table" v-loading="rankObjects.apps.tableLoading">
            <el-table class="common-el-table-styles" :data="rankObjects.apps.tableData" :height="300" style="width: 100%">
              <el-table-column prop="date" label="排行" width="40" class-name="rank-col">
                <template slot-scope="{ $index }">
                  <img v-if="$index < 3" class="rank-image" :src="`/images/homepage-rank-index${$index + 1}.png`" alt="rank-index1" />
                  <div v-else>{{ $index + 1 }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="productName" label="应用名称" show-overflow-tooltip width="240"> </el-table-column>
              <el-table-column prop="amount" label="实际消耗"> </el-table-column>
              <el-table-column prop="createRoleNum" label="创角数"> </el-table-column>
              <el-table-column prop="createRoleCost" label="创角成本"> </el-table-column>
              <el-table-column prop="newPayCost" label="付费成本">
                <template slot-scope="{ row }">
                  <div>{{ row.newPayCost.toFixed(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="newRoleRate" label="ROI">
                <template slot-scope="{ row }">
                  <div>{{ row.newRoleRate | toPercent }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div style="height: 16px"></div>
    </div>
  </div>
</template>
<script>
import Echarts from 'echarts'
import moment from 'moment'
import { isArray } from '@/common/js/utils'

import { getLocal, setLocal } from '@/common/js/api'
import FitlerForm from './components/form/filter-form.vue'
import Summaries from './components/summary/index.vue'
import LineChart from './components/ad-data/index.vue'
import BlockTitle from './components/titles/index.vue'

import getChartOptions from './consts/pie-opts.js'
import { mediaItems, displayItems } from './consts/index.js'

import { getRankDataByType, getMediaChartData, getHomeSummariesData } from '@/api/dashboard.model'
import { toPercent } from '@/common/js/filters'

import { initPageData, GAME_GROUPS, MEDIAS } from '@/data/global-opts'

// 当前页面需要的下拉数据项 ref: src\data\global-opts.js
const PAGE_REQUIRED_OPTS = initPageData([GAME_GROUPS, MEDIAS])

let timer = null

export default {
  components: {
    FitlerForm,
    Summaries,
    LineChart,
    BlockTitle
  },
  data() {
    // 获取本地保存的汇总列配置或者使用默认的
    // tiangong\src\views\dashboard\index\components\summary\index.vue  onItemChange方法设置变更后的汇总列
    const summaryCols = getLocal('summary-cols') || [1, 2, 3, 9, 7, 10, 11, 12]

    // 获取本地保存的筛选项配置
    const filterObjs = getLocal('summary-query-items')

    return {
      pieInstance: null,
      summaryLoading: false,

      summaryData: [], // 汇总数据
      currSummaries: summaryCols, // 当前选中的展示列
      filterObjects: {
        // 汇总数据查询参数
        dateType: 1,
        opIds: [],
        projectGroupOpIds: [],
        mediaIds: [],
        gameIds: [],
        gameGroupIds: [],
        adAccountIdList: [],
        dateRange: [new Date(), new Date()],
        ...filterObjs
      },
      rankObjects: {
        // 人员排行
        users: {
          // 查询参数
          query: {
            tableType: 1,
            rankType: 'amount',
            sort: 'real_consume',
            dateType: 1,
            gameGroupIds: []
          },
          // 表格数据
          tableData: [],
          tableLoading: false
        },
        // 媒体分布
        medias: {
          query: {
            sort: 'real_consume',
            gameGroupIds: [],
            dateType: 1
          },
          chartData: [],
          chartLoading: false
        },
        // 素材排行
        materials: {
          query: {
            tableType: 2,
            sort: 'real_consume',
            dateType: 1,
            mediaIds: []
          },
          // 表格数据
          tableData: [],
          tableLoading: false
        },
        // 应用排行
        apps: {
          query: {
            tableType: 3,
            sort: 'real_consume',
            dateType: 1,
            mediaIds: []
          },
          // 表格数据
          tableData: [],
          tableLoading: false
        }
      }
    }
  },

  computed: {
    ...PAGE_REQUIRED_OPTS,

    mediaItems() {
      return mediaItems
    },
    summaryList() {
      return this.currSummaries.map((value) => {
        const item = displayItems.find((d) => d.value === value)
        const dataItem = this.summaryData.find((d) => d.key === item.key)
        return Object.assign({}, item, dataItem)
      })
    },

    // 切换媒体分布排行类型时，获得当前排行的数据
    currChartData() {
      const { query, chartData } = this.rankObjects.medias
      const { rankType } = query
      const data = {
        legend: [],
        percents: [],
        series: []
      }

      isArray(chartData) &&
        chartData.forEach((d) => {
          data.legend.push(`${d.mediaName}`)
          data.series.push({
            name: d.mediaName + '',
            value: d[rankType],
            percent: `${toPercent(d[rankType + 'Percent'], 100)}`,
            extraValue: `(${d[rankType]})`
          })
        })

      return data
    }
  },
  created() {
    // 获取汇总数据
    this.querySummaryData()
    // 获取排行数据
    this.queryRankData()
  },
  methods: {
    /**
     * @description: 获取汇总数据
     */
    querySummaryData() {
      // 保存筛选项到本地存储，下次进入页面时显示
      this.setLocalFilterObjects()

      // 查询汇总数据
      const { dateType, projectGroupOpIds } = this.filterObjects
      const tempObj = Object.assign({}, this.filterObjects, {
        projectGroupOpIds: projectGroupOpIds.join(',')
      })

      // 自定义时间段
      if (tempObj.dateType === 7) {
        const [start, end] = tempObj.dateRange
        if (!start || !end) return
        tempObj.beginTime = moment(start).format('YYYY-MM-DD')
        tempObj.endTime = moment(end).format('YYYY-MM-DD')
      }
      this.summaryLoading = true
      const { dateRange, ...params } = tempObj
      getHomeSummariesData(params).then((data) => {
        if (data && isArray(data)) {
          this.summaryData = data
        }
        this.summaryLoading = false
      })
      // 查询图表数据
      this.$nextTick(() => {
        this.$refs.lineChartRef.queryLineData()
      })
    },
    /**
     * @description: 清除查询表单
     */
    clearFilterForm() {
      this.filterObjects = {
        ...this.filterObjects,
        opIds: [],
        initProjectGroupIds: [],
        mediaIds: [],
        gameIds: [],
        gameGroupIds: [],
        adAccountIdList: []
      }
    },
    /**
     * @description: 获取素材、人员、应用的排行数据
     */
    queryRankData() {
      // 获取人员排行
      this.getUsersRankData()
      // 获取素材排行
      this.getMaterialsRankData()
      // 获取应用排行
      this.getAppsRankData()
      // 获取饼图数据
      this.getPieData()
    },
    /**
     * @description: 保存筛选条件到本地
     */
    setLocalFilterObjects() {
      // 缓存记录上次的选中的筛选项，筛选项有：媒体、项目组、应用组、应用、人员、账号；
      const { dateRange, dateType, ...rest } = this.filterObjects
      setLocal('summary-query-items', rest)
    },
    /**
     * @description: 素材排行
     */
    getMaterialsRankData() {
      const { materials } = this.rankObjects
      materials.tableLoading = true
      getRankDataByType(materials.query).then((data) => {
        if (data && isArray(data)) {
          materials.tableData = data
        }
        materials.tableLoading = false
      })
    },
    /**
     * @description: 应用排行
     */
    getAppsRankData() {
      const { apps } = this.rankObjects
      apps.tableLoading = true
      getRankDataByType(apps.query).then((data) => {
        if (data && isArray(data)) {
          apps.tableData = data
        }
        apps.tableLoading = false
      })
    },

    /**
     * @description: 获取人员排行数据
     */
    getUsersRankData() {
      const { users } = this.rankObjects
      users.tableLoading = true
      getRankDataByType(users.query).then((data) => {
        if (data && isArray(data)) {
          users.tableData = data
        }
        users.tableLoading = false
      })
    },

    /**
     * @description: 获取饼图数据
     */
    getPieData() {
      const { sort } = this.rankObjects.medias.query

      const item = mediaItems.find((item) => item.sort === sort)

      this.rankObjects.medias.query.rankType = item.value
      clearTimeout(timer)
      timer = setTimeout(() => {
        const { medias } = this.rankObjects
        // 获取饼图数据
        medias.chartLoading = true
        getMediaChartData(medias.query).then((data) => {
          if (isArray(data)) {
            medias.chartData = data
            medias.chartLoading = false
            this.initPieChart()
          }
        })
      }, 1000)
    },
    /**
     * @description: 初始化饼图
     */
    async initPieChart() {
      await this.$nextTick()
      this.pieInstance = Echarts.init(this.$refs.pieChartRef)

      const chartOptions = getChartOptions(this.currChartData)
      this.pieInstance.setOption(chartOptions)
    }
  }
}
</script>
<style scoped lang="scss">
.mt-0 {
  margin-top: 0;
}
.mr-16px {
  margin-right: 16px;
}
#dashboard-page {
  min-width: 1600px;
  overflow: auto;
  .page-wrapper {
    padding: 0 16px;
    .tables {
      margin-top: 30px;
      display: grid;
      grid-template-columns: repeat(2, calc(50% - 8px));
      grid-gap: 16px;
      grid-row-gap: 30px;

      ::v-deep .table {
        position: relative;
        .rank-image {
          width: 20px;
        }
        .rank-col {
          .cell {
            text-align: center;
          }
        }
      }
    }
    .block-content {
      padding: 15px;
      background-color: #fff;
      border-radius: 4px;

      .ad {
        .title {
          font-size: 18px;
          margin: 12px 0;
          font-weight: 600;
        }
      }
    }
  }
}
</style>
